function adjustListingHeight() {
    const $filter = $('.js-listing-filter'),
        $content = $('.js-listing-content'),
        $header = $('.js-listing-header');

    $content.height('');

    if (checkResolution('cxs;xs;sm')) {
        return false;
    }

    if (
        $filter.outerHeight(true) >
        $content.outerHeight(true) + $header.outerHeight(true)
    ) {
        $content.outerHeight(
            $filter.outerHeight(true) - $header.outerHeight(true)
        );
    }
}

function adjustChekcboxLimitHeight() {
    const $wrappers = $('.checkbox__list__wrap--limit');

    if (!$wrappers.length) {
        return false;
    }

    $wrappers.each(function() {
        const $wrapper = $(this),
            $items = $wrapper.find('.checkbox__list__col');

        let itemsHeight = 0;

        $items.slice(0, 5).each(function() {
            itemsHeight += $(this).height();
        });

        if (itemsHeight > $wrapper.outerHeight()) {
            $wrapper.css('max-height', itemsHeight);
        }
    });
}

rEvent.on('Window.doneResizing', function() {
    adjustListingHeight();
});

rEvent.on('Listing.changeView', function() {
    adjustListingHeight();
});

rEvent.on('Listing.fetchedData', function() {
    adjustListingHeight();
});

adjustListingHeight();

function setSezonneSlider() {
    const $slider = $('.js-group-slider-holder:not(.collapse)').find(
        '.js-tab-products-slider:not(.slick-initialized)'
    );

    $slider
        .slick({
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $slider.parent().find('.slick-prev'),
            nextArrow: $slider.parent().find('.slick-next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1.8,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 370,
                    settings: {
                        slidesToShow: 1.6,
                        slidesToScroll: 1,
                    },
                },
            ],
        })
        .on('setPosition', function(event, slick) {
            bLazy.revalidate();

            slick.$slides
                .find('.slider__products__list__item')
                .css('height', 'auto')
                .css('height', slick.$slideTrack.height() + 'px');
        });

    requestAnimationFrame(function() {
        bLazy.revalidate();
        $slider.slick('refresh');
        $slider.slick('setPosition');
    });
}

$(function() {
    adjustListingHeight();

    setTimeout(function() {
        adjustListingHeight();
    }, 250);

    $('.js-lego-ages-item').on('click', function(e) {
        const $agesFilter = $('.js-filter-ages'),
            index = $(this).data('index'),
            $agesInputs = $agesFilter.find(
                'input[name="filter[custom_age][]"]'
            );

        e.preventDefault();

        $agesInputs.prop('checked', false);
        $agesInputs.eq(index).prop('checked', true);

        Filter.submit();

        slideTo($('.js-listing-wrapper'), -50);
    });

    $('.js-top-manufacturer').on('click', function(e) {
        const id = $(this).data('id');

        e.preventDefault();

        $('select[name="filter[manufacturers][]"]')
            .multiselect('deselectAll')
            .multiselect('select', id);

        // $('.filter__content__box--manufactures input:checked').prop('checked', false);
        // $(`.filter__content__box--manufactures input[value="${id}"]`).prop('checked', true);
        // $('input[name="filter[manufacturers][]"]').multiselect('refresh');

        Filter.submit();

        slideTo($('.js-listing-wrapper'), -50);
    });

    $('#price_range').on('slidecreate', function(event, ui) {
        $('.slider__wrap__item--numbermin .number').text(
            Format.price($('#price_range').slider('values', 0))
        );
        $('.slider__wrap__item--numbermax .number').text(
            Format.price($('#price_range').slider('values', 1))
        );
    });

    $('#price_range').on('slidechange', function(event, ui) {
        $('.slider__wrap__item--numbermin .number').text(
            Format.price(ui.values[0])
        );
        $('.slider__wrap__item--numbermax .number').text(
            Format.price(ui.values[1])
        );
    });

    $('#price_range').on('slide', function(event, ui) {
        $('.slider__wrap__item--numbermin .number').text(
            Format.price(ui.values[0])
        );
        $('.slider__wrap__item--numbermax .number').text(
            Format.price(ui.values[1])
        );
    });

    $('.filter_price_range').bind('change', function() {
        var $checked = $('.filter_price_range:checked'),
            min = 99999,
            max = 0;

        if ($checked.size() == 0) {
            $('#price_range__from').val('');
            $('#price_range-range-to').val('');
            $('#price_range').slider('values', [
                $('#price_range').data('uiSlider').options.min,
                $('#price_range').data('uiSlider').options.max,
            ]);

            Filter.submit();

            return;
        }

        $checked.each(function() {
            var priceArray = $(this)
                    .val()
                    .split(';'),
                actualMin = parseFloat(priceArray[0]),
                actualMax = parseFloat(priceArray[1]);

            if (actualMin < min) {
                min = actualMin;
            }

            if (actualMax > max) {
                max = actualMax;
            }
        });

        $('#price_range__from').val(min);
        $('#price_range-range-to').val(max);
        $('#price_range').slider('values', [min, max]);
        Filter.submit();
    });

    $('.filter__sort').bind('click', function() {
        var key = $(this).data('sort');

        $('#filter-sort').val(key);
        $('.filter__sort').removeClass('active');
        $(this).addClass('active');
        Filter.submit();

        return false;
    });
    $('.filter__sort[data-sort="' + $('#filter-sort').val() + '"]').addClass(
        'active'
    );

    /* Beg - show more checkbox in filter */
    adjustChekcboxLimitHeight();

    $('.checkbox__list__more a').on('click', function() {
        $(this)
            .parents('.checkbox__list__wrap--limit')
            .addClass('open');
        $(this).remove();

        adjustListingHeight();

        return false;
    });
    /* End - show more checkbox in filter */

    /* Beg - Show filter */
    $('.jsShowFilter').on('click', function() {
        if (
            $(this)
                .parents('.filter')
                .hasClass('open')
        ) {
            $(this)
                .parents('.filter')
                .removeClass('open');
            $(this)
                .children('span')
                .text($(this).attr('data-show'));
            $('.filter__form__bottom').slideUp('400');
        } else {
            if (
                !$(this)
                    .parents('.filter')
                    .hasClass('active')
            ) {
                $(this)
                    .parents('.filter')
                    .addClass('open');
                $(this)
                    .children('span')
                    .text($(this).attr('data-hide'));
                $('.filter__form__bottom').slideDown('400', function() {
                    //check_height_tabcontent();
                });
            }
        }

        if (
            $(this)
                .parents('.filter')
                .hasClass('active')
        ) {
            $(this)
                .parents('.filter')
                .removeClass('open');
            $(this)
                .children('span')
                .text($(this).attr('data-show'));

            $('.filter__form__bottom').slideUp('400', function() {
                $('.filter').removeClass('active');
            });
        }

        return false;
    });

    $('.jsHideFilter').on('click', function() {
        $('.filter input').prop('checked', false);

        $(this)
            .parents('.filter')
            .removeClass('open');
        $('.filter__box--btn .btn')
            .children('span')
            .text($('.filter__box--btn .btn').attr('data-show'));

        $('.filter__form__bottom').slideUp('400', function() {
            $('.filter')
                .removeClass('open')
                .removeClass('active');
        });

        setTimeout(function() {
            slideTo($('.products'));
        }, 450);

        return false;
    });

    $('.jsResetFilter').on('click', function() {
        $('.filter input').prop('checked', false);

        setTimeout(function() {
            slideTo($('.products'));
        }, 450);

        return false;
    });
    /* End - Hide filter */

    $('.filter__content__nav a').on('click', function(e) {
        if (
            $(this)
                .parents('li')
                .hasClass('active')
        ) {
            $(this)
                .parent('li')
                .removeClass('active');
            $('.tab-pane' + $(this).attr('href')).removeClass('active');
        } else {
            $(this)
                .parent('li')
                .addClass('active');
            $('.tab-pane' + $(this).attr('href')).addClass('active');
        }
        return false;
    });
    /* End - Tabs */

    $('.js-collapse-content').shorten({
        showChars: $('.js-collapse-content').data('chars-count')
            ? $('.js-collapse-content').data('chars-count')
            : 120,
        ellipsesText: '',
        moreText: $('.js-collapse-content').data('more-text'),
        lessText: $('.js-collapse-content').data('less-text'),
    });

    $('.slider-tops-products').slick({
        dots: false,
        arrows: false,
        infinite: false,
        adaptiveHeight: false,
        speed: 300,
        rows: 3,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    rows: 1,
                    slidesToShow: 2.5,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    rows: 1,
                    slidesToShow: 2.2,
                },
            },
            {
                breakpoint: 350,
                settings: {
                    rows: 1,
                    slidesToShow: 1.5,
                },
            },
        ],
    });

    $('.js-type-articles-slider').each(function() {
        $(this).slick({
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: $(this)
                .siblings('.type-articles__nav')
                .find('.is-prev'),
            nextArrow: $(this)
                .siblings('.type-articles__nav')
                .find('.is-next'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        infinite: false,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    });

    $('.js-lego-categories-more').on('click', function() {
        $(this)
            .siblings('.js-lego-categories-item')
            .addClass('is-visible');
        $(this).remove();

        bLazy.revalidate();

        setTimeout(function() {
            bLazy.revalidate();
        }, 250);
    });

    $('.js-fake-types-filter').on('click', function(e) {
        const value = $(this).data('value');

        e.preventDefault();

        // $('#filter').find(`input[name="filter[types][]"][value="${$(this).data('value')}"]`).prop('checked', true);
        $('#filter')
            .find(`input[name="filter[types][]"]`)
            .each(function() {
                if ($(this).val() == value) {
                    $(this).prop('checked', true);
                } else {
                    $(this).prop('checked', false);
                }
            });

        Filter.submit();

        slideTo($('.js-listing-wrapper'), -50);
    });

    check_filter_position();

    // sezonne slajder
    const $seasonSlider = $('.js-group-slider');

    $seasonSlider.find('.c-groups-slider__nav .c-btn').on('click', function() {
        $(this)
            .addClass('is-active')
            .siblings()
            .removeClass('is-active');
        $('.js-group-slider-holder').addClass('collapse');
        $('.js-group-slider-holder#' + $(this).attr('data-tab')).removeClass(
            'collapse'
        );

        setSezonneSlider();
        $('.js-group-slider')
            .find('.js-tab-products-slider')
            .slick('setPosition');

        return false;
    });

    setSezonneSlider();
});

$(window).scroll(function() {
    check_filter_position();
});

$(window).resize(function() {
    check_filter_position();
});

function check_filter_position() {
    if (!$('.header__menu__btn').is(':visible') && $('.filter').length) {
        const $filterScroll = $('.filter__scroll'),
            windowScrollTop = $(window).scrollTop(),
            filterOffset =
                $('.filter').offset().top + $('.filter').outerHeight(),
            listingOffset =
                $('.js-listing-content').offset().top +
                $('.js-listing-content').height();

        $filterScroll.toggleClass(
            'showbutton',
            windowScrollTop > filterOffset && windowScrollTop < listingOffset
        );
    }
}
